import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Exit3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5.92333 2.73052L16.1532 1.05368C16.3695 1.01895 16.5894 1 16.8128 1C18.5214 1 19.9488 2.04842 20.3057 3.45369H25.417C27.3959 3.45685 28.9964 4.85896 29 6.59264V25.4074C28.9964 27.1411 27.3959 28.5432 25.417 28.5463H20.3057C19.9488 29.9484 18.5214 30.9968 16.8164 31C16.5894 31 16.3659 30.9811 16.146 30.9463L5.91613 29.2505C4.22557 28.9663 3 27.6716 3 26.1653V5.81579C3 4.30633 4.22916 3.00842 5.92333 2.73052ZM20.3922 26.4558H25.417C26.0767 26.4526 26.6101 25.9853 26.6101 25.4074V6.59264C26.6101 6.01474 26.0767 5.54738 25.417 5.54738H20.3922V26.4558ZM13.2299 17.0169C13.2299 17.5947 13.7633 18.0621 14.423 18.0621C15.0826 18.0621 15.6161 17.5947 15.6161 17.0169V14.9832C15.6161 14.4053 15.0826 13.9379 14.423 13.9379H14.4194C13.7633 13.9379 13.2263 14.4053 13.2299 14.9832V17.0169Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
